import axios from "axios";
import "../../../setup/config/apiConfig";

export const RESET = "RESET";
export const GET_RATE_REFERENCES = "GET_RATE_REFERENCES";
export const GET_RATE_REFERENCES_RESPONSE = "GET_RATE_REFERENCES_RESPONSE";
export const GET_RATE_REFERENCES_RESPONSE_FAIL =
  "GET_RATE_REFERENCES_RESPONSE_FAIL";
export const GET_RATE_REFERENCE = "GET_RATE_REFERENCE";
export const GET_RATE_REFERENCE_RESPONSE = "GET_RATE_REFERENCE_RESPONSE";
export const GET_RATE_REFERENCE_RESPONSE_FAIL = "GET_RATE_REFERENCE_RESPONSE_FAIL";
export const CREATE_RATE_REFERENCE = "CREATE_RATE_REFERENCE";
export const CREATE_RATE_REFERENCE_RESPONSE = "CREATE_RATE_REFERENCE_RESPONSE";
export const CREATE_RATE_REFERENCE_RESPONSE_FAIL =
  "CREATE_RATE_REFERENCE_RESPONSE_FAIL";
export const UPDATE_RATE_REFERENCE = "UPDATE_RATE_REFERENCE";
export const UPDATE_RATE_REFERENCE_RESPONSE = "UPDATE_RATE_REFERENCE_RESPONSE";
export const UPDATE_RATE_REFERENCE_RESPONSE_FAIL =
  "UPDATE_RATE_REFERENCE_RESPONSE_FAIL";
export const DELETE_RATE_REFERENCE = "DELETE_RATE_REFERENCE";
export const DELETE_RATE_REFERENCE_RESPONSE = "DELETE_RATE_REFERENCE_RESPONSE";
export const DELETE_RATE_REFERENCE_RESPONSE_FAIL =
  "DELETE_RATE_REFERENCE_RESPONSE_FAIL";

export function get(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_RATE_REFERENCES,
      isLoading,
    });

    return axios
      .get("/vendorrateschedule")
      .then((response) => {
        dispatch({
          type: GET_RATE_REFERENCES_RESPONSE,
          rateReferences: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_RATE_REFERENCES_RESPONSE_FAIL,
          isLoading: false,
          error,
        });
        throw error;
      });
  };
}

export function getByUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_RATE_REFERENCE,
      isLoading,
    });

    return axios
      .get(`/vendorrateschedule/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_RATE_REFERENCE_RESPONSE,
          rateReference: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_RATE_REFERENCE_RESPONSE_FAIL,
          isLoading: false,
          error,
        });
        throw error;
      });
  };
}

export function getByVendorId(vendorId, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_RATE_REFERENCES,
      isLoading,
    });

    return axios
      .get(`/vendorrateschedule/vendor/${vendorId}`)
      .then((response) => {
        dispatch({
          type: GET_RATE_REFERENCES_RESPONSE,
          rateReferences: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_RATE_REFERENCES_RESPONSE_FAIL,
          isLoading: false,
          error,
        });
        throw error;
      });
  };
}

export function createRateReference(rateReference, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: CREATE_RATE_REFERENCE,
      isLoading,
    });

    return axios
      .post("/vendorrateschedule", rateReference)
      .then((response) => {
        dispatch({
          type: CREATE_RATE_REFERENCE_RESPONSE,
          rateReference: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: CREATE_RATE_REFERENCE_RESPONSE_FAIL,
          isLoading: false,
          error,
        });
        throw error;
      });
  };
}

export function updateRateReference(uuid, rateReference, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_RATE_REFERENCE,
      isLoading,
    });

    return axios
      .put(`/vendorrateschedule/${uuid}`, rateReference)
      .then((response) => {
        dispatch({
          type: UPDATE_RATE_REFERENCE_RESPONSE,
          rateReference: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_RATE_REFERENCE_RESPONSE_FAIL,
          isLoading: false,
          error,
        });
        throw error;
      });
  };
}

export function deleteRateReference(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: DELETE_RATE_REFERENCE,
      isLoading,
    });

    return axios
      .delete(`/vendorrateschedule/${uuid}`)
      .then((response) => {
        dispatch({
          type: DELETE_RATE_REFERENCE_RESPONSE,
          uuid,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: DELETE_RATE_REFERENCE_RESPONSE_FAIL,
          isLoading: false,
          error,
        });
        throw error;
      });
  };
}
